import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pagereferencetype"
    }}>{`PageReferenceType`}</h1>
    <p>{`Options for index page references.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CURRENT_PAGE`}</strong>{` = 1668444263`}</p>
      <p parentName="blockquote">{`The page on which the index entry is located.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TO_NEXT_STYLE_CHANGE`}</strong>{` = 1953395555`}</p>
      <p parentName="blockquote">{`The range of pages from the page containing the index entry to the page containing the next paragraph style change.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TO_NEXT_USE_OF_STYLE`}</strong>{` = 1953396083`}</p>
      <p parentName="blockquote">{`The range of pages from the page containing the index entry to the page that contains the next occurrance of the specified paragraph style. If no paragraph style is specified, the paragraph style of the index entry paragraph is used.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TO_END_OF_STORY`}</strong>{` = 1701802868`}</p>
      <p parentName="blockquote">{`The last page in the story containing the index entry.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TO_END_OF_DOCUMENT`}</strong>{` = 1701799011`}</p>
      <p parentName="blockquote">{`The last page in the document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TO_END_OF_SECTION`}</strong>{` = 1701802851`}</p>
      <p parentName="blockquote">{`The last page in the numbered section containing the index entry.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FOR_NEXT_N_PARAGRAPHS`}</strong>{` = 1718513778`}</p>
      <p parentName="blockquote">{`The range of pages from the page containing the index entry to the page containing the nth full paragraph from the paragraph containing the index entry (where n is the number of paragraphs to include).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FOR_NEXT_N_PAGES`}</strong>{` = 1718513767`}</p>
      <p parentName="blockquote">{`The range of pages from the page containing the inedex entry to the nth page after that page (where n is the number of pages to include).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUPPRESS_PAGE_NUMBERS`}</strong>{` = 1852863079`}</p>
      <p parentName="blockquote">{`Turns off page numbers for the index topic.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      